import React, {useEffect, useRef, useState} from 'react';
import BookPreview from "../bookPreview/bookPreview";
import './book-list.css'
import Loader from "../loader/loader";
import EmptyListMessage from "../emptyListMessage/EmptyListMessage";
import Pagination from "../pagination/Pagination";
import SorterLimiter from "../SorterLimiter/SorterLimiter";
import LoadingBookPreview from "../loadingBookPreview/loadingBookPreview";
import {BookCommon} from "../../models/Book";


interface IBookListPros {
    books:BookCommon[],
    totalCount:number,
    isLoading:boolean,
    error:string | null
}


const BookList = (props:IBookListPros) => {
    const [gridType,setGridType] = useState(1);

    const getLoadingBlocks = () => {
      const elems:JSX.Element[] = [];
          for(let i=0; i<3;i++)
          {
              elems.push(<div key={`load-${i}`} className={"col-sm"}><LoadingBookPreview gridType={gridType}/></div>)
          }
      return elems;
    }

    return (
        <div className={"container pb-3 book-list"}>
            <SorterLimiter totalCount={props.totalCount}/>
            <div className={"book-list__grid-types mb-1"}>
                <i className={`book-list__grid-type 
                               bi bi-square-fill me-2 
                               ${gridType === 1 ? "book-list__grid-type_active" : ""}`}
                   onClick={()=>setGridType(1)}>
                </i>
                <i className={`book-list__grid-type book-list__grid-type_type_2 
                               bi bi-grid-fill me-2 
                               ${gridType === 2 ? "book-list__grid-type_active" : ""}`}
                   onClick={()=>setGridType(2)}>
                </i>
                <i className={`book-list__grid-type book-list__grid-type_type_3
                               bi bi-grid-3x3-gap-fill
                               ${gridType === 3 ? "book-list__grid-type_active" : ""}`}
                   onClick={()=>setGridType(3)}>
                </i>
                
            </div>
            {
                props.isLoading && <Loader/>
            }
            {
                !props.isLoading && props.error && <p>{props.error}</p>
            }

            <div className={`book-list__content row row-cols-sm-${gridType} g-2 mb-3`}>
                {
                    props.isLoading && getLoadingBlocks().map(value => value)
                }
                {
                    props.books?.length > 0 && !props.isLoading && props.books.map((book)=>
                        <div key={book.id+'-'+book.type} className={"col-sm"}>
                            <BookPreview bookPreview={book} gridType={gridType}/>
                        </div>
                    )
                }
                {
                    props.books?.length == 0 && !props.isLoading && <EmptyListMessage/>
                }
            </div>
            {props.totalCount > 0 && <Pagination totalCount={props.totalCount}/>}
        </div>
    );
};

export default BookList;